import { render } from "./ImageUpload.vue?vue&type=template&id=a799e8f2"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/foderboxen/admin.foderboxen.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__